import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0bb76f96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "colors" }
const _hoisted_2 = { class: "colors__left" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "brush-map__subtitle" }, "TREATMENT", -1))
const _hoisted_4 = { class: "colors__left-list" }
const _hoisted_5 = { class: "colors__right" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", { class: "brush-map__subtitle" }, "PREVENTION", -1))
const _hoisted_7 = { class: "colors__right-list" }

import { ref } from 'vue'
import BrushMapListItem from './components/BrushMapListItem.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const leftList = ref([
  {
    color: '#CE5099',
    colorName: '10',
    type: 1,
  },
  {
    color: '#EC1C1C',
    colorName: '12',
    type: 1,
  },
  {
    color: '#761238',
    colorName: '13',
    type: 1,
  },
  {
    color: '#F3701B',
    colorName: '14',
    type: 1,
  },
  {
    color: '#FEDF12',
    colorName: '17',
    type: 1,
  },
  {
    color: '#4079C4',
    colorName: '20',
    type: 1,
  },
  {
    color: '#785CA6',
    colorName: '21',
    type: 1,
  },
  {
    color: '#A1A5A8',
    colorName: '27',
    type: 1,
  },
  {
    color: '#64696C',
    colorName: '33',
    type: 1,
  },
])

const rightList = ref([
  {
    color: '#DDBCBC',
    colorName: '06',
    type: 2,
  },
  {
    color: '#F4B3CF',
    colorName: '07',
    type: 2,
  },
  {
    color: '#FDAB59',
    colorName: '08',
    type: 2,
  },
  {
    color: '#B7D48E',
    colorName: '09',
    type: 2,
  },
  {
    color: '#A2BDCE',
    colorName: '11',
    type: 2,
  },
])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("ul", _hoisted_4, [
        _createVNode(BrushMapListItem, {
          firstPosition: 0,
          list: leftList.value,
          secondPosition: 8,
          onChangeColor: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('changeColor', $event)))
        }, null, 8, ["list"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("ul", _hoisted_7, [
        _createVNode(BrushMapListItem, {
          firstPosition: 0,
          list: rightList.value,
          secondPosition: 5,
          onChangeColor: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('changeColor', $event)))
        }, null, 8, ["list"])
      ])
    ])
  ]))
}
}

})